import React, { useState, useEffect } from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { isMobile } from "react-device-detect";
import { OutageTypeDetailDictionary } from "../helpers/OutageTypeDetailDictionary";

export const outageTypes = [
    "Planned Maintenance",
    "Breakdown",
    "Derate",
    "DNO"
]

const OutageDetailSelector: React.FC<IOutageDetailSelector> = ({ outageType, setOutageType, outageTypeDetail, setOutageTypeDetail, disabled }) => {
    const [detailList, setDetailList] = useState<string[]>(OutageTypeDetailDictionary[outageType] || []);

    const handleOutageTypeChange = (event: SelectChangeEvent) => {
        setOutageType(event.target.value as string)
    }
    const handleOutageTypeDetailChange = (event: SelectChangeEvent) => {
        setOutageTypeDetail(event.target.value as string)
    }
    
    useEffect(() => {
        var details = OutageTypeDetailDictionary[outageType];
        if (details !== undefined) {
            if (details.indexOf(outageTypeDetail) === -1) { // Reason needs to change
                setDetailList(details)
                setOutageTypeDetail(details[0])
            }
        }
        else {
            setOutageType(outageTypes[0])
        }
    }, [outageType])

    return (
        <>
            <Grid xs={isMobile ? 6 : 3}>
                <Box>
                    <FormControl fullWidth>
                        <InputLabel id="Outage-Type-Select-Label">Outage Type</InputLabel>
                        <Select
                            labelId="Outage-Type-Select-Label"
                            id="Outage-Type-Select"
                            value={outageType}
                            label="Outage Type"
                            disabled={disabled}
                            onChange={handleOutageTypeChange}
                        >
                            {
                                outageTypes.map((type) =>
                                    <MenuItem key={type} value={type}>{type}</MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                </Box>
            </Grid>
            <Grid xs={isMobile ? 6 : 3}>
                <Box>
                    <FormControl fullWidth>
                        <InputLabel id="Outage-Type-Detail-Select-Label">Outage Type Detail</InputLabel>
                        <Select
                            labelId="Outage-Type-Detail-Select-Label"
                            id="Outage-Type-Detail-Select"
                            value={detailList.indexOf(outageTypeDetail) < 0 ? '' : outageTypeDetail}
                            label="Outage Type Detail"
                            disabled={disabled}
                            onChange={handleOutageTypeDetailChange}
                        >
                            {
                                detailList.map((detail) =>
                                    <MenuItem key={detail} value={detail}>{detail}</MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                </Box>
            </Grid></>
    );

}

export interface IOutageDetailSelector {
    outageType: string;
    setOutageType: (outageType: string) => void;
    outageTypeDetail: string;
    setOutageTypeDetail: (reason: string) => void;
    disabled: boolean
}

export default OutageDetailSelector;